module.exports = __webpack_public_path__ + "static/media/img_social03.76fcd6ed.jpg";